import React from "react";
import { LOGO_URL, CONTACT, NAV_LINKS } from "@/lib/constants";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const handleClick = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-brand-blue text-white pt-20 pb-10 px-6 md:px-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 pb-14 border-b border-white/15">
          <div className="lg:col-span-5">
            <div className="bg-white rounded-2xl inline-block p-3">
              <img src={LOGO_URL} alt="Reading Physio" className="h-14 w-auto" />
            </div>
            <p className="mt-6 text-white/80 text-base leading-relaxed max-w-md">
              Fall and Frailty Prevention Clinic by Reading Physio — chartered physiotherapy and clinical strength
              training for seniors and individuals recovering from injury across Reading and Berkshire.
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display text-lg text-brand-gold mb-5">Explore</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => handleClick(l.id)}
                    className="text-white/80 hover:text-white transition-colors"
                    data-testid={`footer-link-${l.id}`}
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-display text-lg text-brand-gold mb-5">Visit or contact us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="shrink-0 mt-1 text-brand-gold" />
                <span className="text-white/90">{CONTACT.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={20} className="shrink-0 mt-1 text-brand-gold" />
                <a href={`tel:${CONTACT.phone}`} className="text-white/90 hover:text-white" data-testid="footer-phone">{CONTACT.phoneDisplay}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={20} className="shrink-0 mt-1 text-brand-gold" />
                <a href={`mailto:${CONTACT.email}`} className="text-white/90 hover:text-white break-all" data-testid="footer-email">{CONTACT.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/60">
          <p>© {new Date().getFullYear()} Reading Physio · Fall and Frailty Prevention Clinic. All rights reserved.</p>
          <div className="flex items-center gap-3" data-testid="footer-accreditations">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/25 text-white/90">
              <span className="font-display text-base text-brand-gold">HCPC</span>
              <span className="text-xs uppercase tracking-wider">Registered</span>
            </span>
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/25 text-white/90">
              <span className="font-display text-base text-brand-gold">CSP</span>
              <span className="text-xs uppercase tracking-wider">Member</span>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
